export default __webpack_public_path__ + "static/media/fav-list-added.e44ead38.svg";